<template>
  <div>
    <v-alert v-show="true" color="primary" value="true" outline>
      {{$t('visioTitle1')}} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>. {{$t('visioTitle2')}}.
    </v-alert> 
    <!-- Indique si la licence n'a pas l'option Recall -->
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      {{ $t('warningVisioDisabled') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>

    <div>
      <!-- Chargement -->
      <div v-if="loadingGet" class="text-xs-center">
        <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
      </div>

      <!-- Formulaire -->
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-switch 
                :label="visioOnOff ? 'VISIO ASSISTANCE ON' : 'DEMANDES DE VISIO ASSISTANCE OFF'"
                v-model="visioOnOff"
                light
                color="primary"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
<!--
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-switch 
                :label="askConfOnOff ? 'Afficher l\'icone de demande de visio-conférence ON' : 'Afficher l\'icone de demande de visio-conférence OFF'"
                v-model="askConfOnOff"
                light
                color="primary"
              ></v-switch>
              <v-switch 
                :label="askVisioOnOff ? 'Afficher l\'icone de demande d\'appel ON' : 'Afficher l\'icone de demande d\'appel OFF'"
                v-model="askVisioOnOff"
                light
                color="primary"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
-->    
      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="postOptions()"
          :disabled="alert"
        >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { DOMAINE, CLOUD } from '../../constants'
export default {
  data () {
    return {
      alert: false,
      visioOnOff: false,
      askVisioOnOff: false,
      askConfOnOff: false,
      // loaders
      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    }
  },

  mounted () {
    this.getOptions()
  },

  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_visioconf'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_visioconf'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  computed: {
    /**
     * @return {String} URL de l'iframe représentant le meeting
     */
    iframePreviewMeeting () {
      return (process.env.NODE_ENV === 'development')
      // ? `${DOMAINE}/dev/fo/incl/inner2019.php?${this.iframeParams}`
      ? `${DOMAINE}/public/config/preview.php?${this.iframeParams}`
      // : `${DOMAINE}/fo/incl/inner2019.php?${this.iframeParams}`
      : `${CLOUD}/config/preview.php?${this.iframeParams}`
    },
    /**
     * @return {String} paramètres des iframes
     */
    iframeParams () {
      let params = ``
      return params
    }
  },

  methods: {
    getOptions () {
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_visioconf.php?lic=' +
            this.$store.state._Sites.siteSelected.LIC_ID
        )
        .then(response => {
          console.log('response', response)
          this.visioOnOff = response.data.LIC_VISIO_ACTIVATED === '1'
          // this.askVisioOnOff = response.data.LIC_VISIO_VISASKVISIO === '1'
          // this.askConfOnOff = response.data.LIC_VISIO_VISASKCONF === '1'
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append(
        'LIC_ID',
        this.$store.state._Sites.siteSelected.LIC_ID
      )
      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'ENT_ID',
        this.$store.state._User.entId
      )
      dataToPost.append('LIC_VISIO_ACTIVATED', this.visioOnOff ? '1' : '0')
      this.loadingPost = true
      this.axios
        .post('post/settings_visioconf.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      this.getOptions()
    }
  }
}
</script>

<style>
.tf-picto-recall {
  height: 45px;
  width: 40px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.5;
}
.tf-picto-recall.selected {
  height : 55px;
  width : 50px;
  opacity: 1;
 /*border: 1px solid red;*/
 box-shadow: 0 3px 5px -1px rgba(0,0,0,.3),0 6px 10px 0 rgba(0,0,0,.34),0 1px 18px 0 rgba(0,0,0,.32)!important;
}
tf-picto-recall.noSelected {
  width : 50px;
  width : 45px;
  border: 0px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Visioconf.vue